import { useMutation, useQueryClient } from '@tanstack/react-query';
import LeadContractService, {
  IIssueContractParams,
} from '@clickersphere/core/services/LeadContractService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { LEAD_CONTRACTS_QUERY_KEY } from './useLeadContracts';

export function useIssueContract() {
  const queryClient = useQueryClient();
  const { buildQueryKey } = useBuildQueryKey();

  const { isPending: issueContractIsPending, mutateAsync: issueContractAsync } =
    useMutation({
      mutationFn: async ({
        leadId,
        data,
      }: {
        leadId: string;
        data: IIssueContractParams;
      }) => LeadContractService.issue(leadId, data),
      onSuccess: async (_data, variables) => {
        await queryClient.invalidateQueries({
          queryKey: buildQueryKey([LEAD_CONTRACTS_QUERY_KEY, variables.leadId]),
        });
      },
    });

  return {
    issueContractAsync,
    issueContractIsPending,
  };
}
